module.exports = __webpack_public_path__ + "img/fun_yyhc.96093008.jpg";